import { ObservableService } from '@app/services/observableService'

import { loaderStatus, loaderHandler } from '../constants'

import type { Loader, LoaderStatus } from '../types'

export abstract class BaseLoader extends ObservableService implements Loader {
  status: LoaderStatus = loaderStatus.NOT_STARTED

  error?: unknown | null

  abstract percent: number | null
  abstract start (): Promise<void> | void
  abstract cancel (): Promise<void> | void

  onStatusChange (callback: (loader: BaseLoader) => void): void {
    this.subscribe(loaderHandler.statusChange, callback)
  }

  onSuccess (callback: (loader: BaseLoader) => void): void {
    this.subscribe(loaderHandler.success, callback)
  }

  onLoading (callback: (loader: BaseLoader) => void): void {
    this.subscribe(loaderHandler.loading, callback)
  }

  onError (callback: (loader: BaseLoader) => void): void {
    this.subscribe(loaderHandler.error, callback)
  }

  onCanceled (callback: (loader: BaseLoader) => void): void {
    this.subscribe(loaderHandler.canceled, callback)
  }

  onComplete (callback: (loader: BaseLoader) => void): void {
    this.subscribe(loaderHandler.complete, callback)
  }

  onProgress (callback: (loader: BaseLoader) => void): void {
    this.subscribe(loaderHandler.progress, callback)
  }

  protected readonly handleLoading = (): void => {
    this.setStatus(loaderStatus.LOADING)
    this.broadcast(loaderHandler.loading, this)
  }

  protected readonly handleSuccess = (): void => {
    this.setStatus(loaderStatus.SUCCESS)
    this.broadcast(loaderHandler.success, this)
  }

  protected readonly handleError = (error: unknown): void => {
    this.setStatus(loaderStatus.ERROR)
    error && (this.error = error)
    this.broadcast(loaderHandler.error, this)
  }

  protected readonly handleCanceled = (): void => {
    this.setStatus(loaderStatus.CANCELED)
    this.broadcast(loaderHandler.canceled, this)
  }

  protected readonly handleComplete = (): void => {
    this.broadcast(loaderHandler.complete, this)
  }

  protected readonly handleProgress = (): void => {
    this.broadcast(loaderHandler.progress, this)
  }

  private setStatus (status: LoaderStatus): void {
    this.status = status
    this.broadcast(loaderHandler.statusChange, this)
  }
}
